import React, { useState } from "react";

const ReadMoreButton = ({ content, maxLength }) => {
  const [isTruncated, setIsTruncated] = useState(true);

  const toggleTruncate = () => {
    setIsTruncated(!isTruncated);
  };

  return (
    <div>
      {isTruncated ? (
        <p className="td-desc">
          {content.length > maxLength ? `${content.substring(0, maxLength)}` : content}
          <button className="readmore-btn" onClick={toggleTruncate}>
            ...more
          </button>
        </p>
      ) : (
        <p className="td-desc">
          {content}
          <button className="readmore-btn" onClick={toggleTruncate}>
            &nbsp;less
          </button>
        </p>
      )}
    </div>
  );
};

export default ReadMoreButton;
